import React from 'react';

export const DashboardTicketsSummaryCards = ({ summary, formatNumber, formatHours }) => {
    return (
        <div className="row g-3 mb-3">
            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-primary h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="fs-12 text-muted text-uppercase">Tickets</div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.totalTickets)}</div>
                    <div className="text-muted fs-11 mt-1">Totales en el período</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-warning h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="fs-12 text-muted text-uppercase">Abiertos</div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.openTickets)}</div>
                    <div className="text-muted fs-11 mt-1">En cola de atención</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-success h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="fs-12 text-muted text-uppercase">Resueltos</div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.resolvedTickets)}</div>
                    <div className="text-muted fs-11 mt-1">Cerrados o resueltos</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-danger h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="fs-12 text-muted text-uppercase">Vencidos</div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.overdueOpenTickets)}</div>
                    <div className="text-muted fs-11 mt-1">Abiertos fuera de tiempo</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-danger h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="fs-12 text-muted text-uppercase">Fuera SLA</div>
                    <div className="fs-4 fw-bold">{formatNumber(summary?.breachedResolvedTickets)}</div>
                    <div className="text-muted fs-11 mt-1">Resueltos tarde</div>
                </div>
            </div>

            <div className="col-12 col-md-6 col-xl-2">
                <div className="card card-body border bg-soft-info h-100 dashboard-kpi-card dashboard-kpi-card--compact">
                    <div className="fs-12 text-muted text-uppercase">Prom. Resolución</div>
                    <div className="fs-4 fw-bold">{formatHours(summary?.avgResolutionHours)}</div>
                    <div className="text-muted fs-11 mt-1">Tiempo promedio</div>
                </div>
            </div>
        </div>
    );
};
